{
  "loading": "Ladataan…",
  "placeholder": "Valitse vaihtoehto..."
}
